/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import KosherSympathyBlock from './KosherSympathyBlock';
import Data from './ViewData';
import { coreBrowsingPageViewSuccessTest } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import GraphqlSeoHeadTags from '../../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const KosherSympathyPage = () => (
    <>
        <GraphqlSeoHeadTags seoData={Data.seo} />
        <KosherSympathyBlock data={Data} />
    </>
);

const enhance = compose(
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
);

export default enhance(KosherSympathyPage);
